import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/img_33.svg")